//auth
export const FETCH_WISHLIST = 'FETCH_WISHLIST';
export const FETCH_WISHLIST_FAILURE = 'FETCH_WISHLIST_FAILURE';
export const SET_WISHLIST = 'SET_WISHLIST';
export const SET_USER = 'SET_USER';
//product-list-store
export const SET_CURRENCY_SYMBOL = 'SET_CURRENCY_SYMBOL';
//delivery.jk
export const SET_SHIPPING_METHOD = 'SET_SHIPPING_METHOD';
export const SET_PAYMENT_METHOD = 'SET_PAYMENT_METHOD';
export const SET_STORE = 'SET_STORE';
export const SET_ERRORS = 'SET_ERRORS';
export const RESET_PAYMENT_METHOD = 'RESET_PAYMENT_METHOD';
export const SET_SHIPPING_CONDITION = 'SET_SHIPPING_CONDITION';
export const RESET_SHIPPING_CONDITION = 'RESET_SHIPPING_CONDITION';
export const STATE_TYPE = 'STATE_TYPE';
export const SET_AUTH_CHECK = 'SET_AUTH_CHECK';
export const SET_CURRENCY = 'SET_CURRENCY';
export const SET_NUMBER_OF_DECIMALS = 'SET_NUMBER_OF_DECIMALS';
export const SET_TOTAL_FROM_VUE = 'SET_TOTAL_FROM_VUE';
export const SET_TOTAL_FROM_VUE_WITHOUT_SELECTIONS = 'SET_TOTAL_FROM_VUE_WITHOUT_SELECTIONS';
export const SET_TOTAL_WITH_SHIPPING = 'SET_TOTAL_WITH_SHIPPING';
//product-list
export const SET_LOADING = 'SET_LOADING';
export const SET_TOOGLE_MODAL = 'SET_TOOGLE_MODAL';
export const SET_MODAL_TYPE = 'SET_MODAL_TYPE';
export const SET_MODAL_ID = 'SET_MODAL_ID';
export const SET_MODAL_CLOSE_BUTTON = 'SET_MODAL_CLOSE_BUTTON';
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';
export const SET_WISHLIST_MODAL_CONTENT = 'SET_WISHLIST_MODAL_CONTENT';
export const SET_WATCHDOG_MODAL_CONTENT = 'SET_WATCHDOG_MODAL_CONTENT';
export const SET_WISHLIST_ICON = 'SET_WISHLIST_ICON';
export const SET_PREVIOUS_MODAL_NAME = 'SET_PREVIOUS_MODAL_NAME';
export const SET_PREVIOUS_MODAL_ID = 'SET_PREVIOUS_MODAL_ID';
export const SET_MODAL_COOKIE = 'SET_MODAL_COOKIE';
